import { IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar } from '@ionic/react';
import { useParams } from 'react-router';
import WWVergetenForm from '../components/WWVergetenForm';

const WWVergeten: React.FC = () => {
  return <WWVergetenForm />;
};

export default WWVergeten;
